import { render, staticRenderFns } from "./modifyRecord.vue?vue&type=template&id=0011180e&scoped=true"
import script from "./modifyRecord.vue?vue&type=script&lang=js"
export * from "./modifyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0011180e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0011180e')) {
      api.createRecord('0011180e', component.options)
    } else {
      api.reload('0011180e', component.options)
    }
    module.hot.accept("./modifyRecord.vue?vue&type=template&id=0011180e&scoped=true", function () {
      api.rerender('0011180e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/modifyRecord.vue"
export default component.exports